import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"loading\"><path d=\"M14.303 18.728h-3.436L3.67 5.272h10.066c4.043.008 7.262 3.172 7.265 7.007-.007 3.536-2.972 6.448-6.697 6.448\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol